import cateringOrderBackend from '@/api/base/cateringOrderBackend'

export default {
  locationConfigs() {
    const { api, paths } = cateringOrderBackend()
    return api.get(paths.locationConfigs())
  }
}
